import {Component, ElementRef, ViewChild} from '@angular/core';
import {RouterOutlet} from "@angular/router";
import {ModalsComponent} from "../../../common/modals/modals.component";
import {ModalsService} from "../../../services/Modals/modals.service";
import { FooterComponent } from 'src/app/common/templates/footer/footer.component';
import { SidebarComponent, SidebarLink } from 'src/app/common/internal-sidebar/internal-sidebar.component';
import { HeaderComponent } from 'src/app/common/templates/header/header.component';
import { ToastComponent } from "src/app/common/toast/toast.component";

@Component({
    selector: 'app-template',
    imports: [
    HeaderComponent,
    SidebarComponent,
    RouterOutlet,
    FooterComponent,
    ModalsComponent,
    ToastComponent
],
    templateUrl: './template.component.html',
    styleUrl: './template.component.scss'
})
export class TemplateComponent {
  @ViewChild('modals',{static: true}) modalComponent!: ModalsComponent;
  @ViewChild('sidebar' , { static : true, read: ElementRef}) sidebar!: ElementRef;
  navLinks: SidebarLink[] = [];

  constructor(private modals: ModalsService) {
  }
  ngOnInit(){
    this.modals.bindComponent(this.modalComponent);
  this.initSidebar();
  }
  initSidebar() {
    this.navLinks = [
      {
        name: 'Dashboard',
        icon: 'bi-house',
        url: '/sysad/dashboard',
      },
      {
        name: 'Users',
        icon: 'bi-people',
        url: '/sysad/users',
      },
      {
        name: 'Archive',
        icon: 'bi-archive',
        url: '/sysad/users/archive',
      },
      {
        name: 'Settings',
        icon: 'bi-gear',
        url: '/sysad/settings',
      },
    ];
  }
  showSidebar(){
    this.sidebar?.nativeElement.focus();
  }

}
